import { createBrowserRouter, Navigate } from 'react-router';

import { AuthenticationPage } from '@/app/auth/AuthenticationPage';
import { AppShellRoute } from '@/app/shell/AppShellRoute';
import { NotFoundPage } from '@/app/shell/NotFoundPage';
import { RootErrorBoundary } from '@/app/shell/RootErrorBoundary';
import { IncidentCallTranscriptPage } from '@/features/call-transcript/IncidentCallTranscriptPage';
import { ChecklistListPage } from '@/features/checklists/ChecklistListPage';
import { CreateIncidentPage } from '@/features/create-incident/CreateIncidentPage';
import { DemoHelperPage } from '@/features/demo/DemoHelperPage';
import { DevAuthenticationPage } from '@/features/dev/DevAuthenticationPage';
import { DevPortalHubPage } from '@/features/dev/portal-hub/DevPortalHubPage';
import { IncidentArchivePage } from '@/features/incident-archive/IncidentArchivePage';
import { IncidentDetailRoute } from '@/features/incident-detail/IncidentDetailRoute';
import { IncidentListPage } from '@/features/incident-list/IncidentListPage';
import { LegacyCreateIncidentRedirect } from '@/features/legacy-urls/LegacyCreateIncidentRedirect';
import { LegacyIncidentRedirect } from '@/features/legacy-urls/LegacyIncidentRedirect';
import { LegacyStartVideoChatRedirect } from '@/features/legacy-urls/LegacyStartVideoChatRedirect';
import { RecordingDetailPage } from '@/features/recordings/RecordingDetailPage';
import { RecordingListPage } from '@/features/recordings/RecordingListPage';
import { SettingsPage } from '@/features/settings/SettingsPage';

export const router = createBrowserRouter([
  {
    errorElement: <RootErrorBoundary />,
    children: [
      { path: '/authentication/:action', element: <AuthenticationPage /> },
      { path: '/portal/incident/:id', element: <LegacyIncidentRedirect /> },
      { path: '/portal/create-incident/:phoneNumber/:id', element: <LegacyCreateIncidentRedirect /> },
      { path: '/incident-list/:id/:phoneNumber', element: <LegacyCreateIncidentRedirect /> },
      { path: '/portal/start-video-chat/:id', element: <LegacyStartVideoChatRedirect /> },
      {
        element: <AppShellRoute />,
        children: [
          { path: '/', element: <Navigate to="/incident-list" replace /> },
          { path: '/incident-list', element: <IncidentListPage /> },
          { path: '/incident-archive', element: <IncidentArchivePage /> },
          { path: '/incident/:incidentId', element: <IncidentDetailRoute /> },
          { path: '/incident/:incidentId/recordings', element: <RecordingListPage /> },
          { path: '/incident/:incidentId/recordings/:videoId', element: <RecordingDetailPage /> },
          { path: '/incident/:incidentId/CallTranscript', element: <IncidentCallTranscriptPage /> },
          { path: '/create-incident', element: <CreateIncidentPage /> },
          { path: '/checklists', element: <ChecklistListPage /> },
          { path: '/settings', element: <SettingsPage /> },
          { path: '/demo/helper', element: <DemoHelperPage /> },
          ...(import.meta.env.DEV
            ? [
                { path: '/dev/authentication', element: <DevAuthenticationPage /> },
                { path: '/dev/portal-hub', element: <DevPortalHubPage /> },
              ]
            : []),
        ],
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
